import { useState } from 'react';

import { updateProfile } from '../services/teacher.service';

export default function useProfileSection(profileId, onUpdate) {
  const [isEditing, setIsEditing] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const openModal = () => {
    setErrors({});
    setIsEditing(true);
  };

  const closeModal = () => {
    setErrors({});
    setIsEditing(false);
  };

  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({ open: true, message, severity });
  };

  const save = async (data, options = {}) => {
    const { successMessage = 'Updated successfully!' } = options;
    setLoading(true);
    setErrors({});

    try {
      const res = await updateProfile(profileId, data);
      showSnackbar(successMessage);
      setIsEditing(false);

      if (onUpdate) {
        onUpdate(res);
      }

      return res;
    } catch (error) {
      const data = error.response?.data;

      if (error.response?.status === 422 && data?.errors) {
        const mapped = {};
        Object.keys(data.errors).forEach((key) => {
          mapped[key] = Array.isArray(data.errors[key]) ? data.errors[key][0] : data.errors[key];
        });
        setErrors(mapped);
      } else {
        showSnackbar(data?.message ?? 'Failed to update. Please try again.', 'error');
      }
    } finally {
      setLoading(false);
    }
  };

  const snackbarProps = {
    open: snackbar.open,
    onClose: () => setSnackbar((s) => ({ ...s, open: false })),
    message: snackbar.message,
    severity: snackbar.severity,
  };

  return {
    isEditing,
    openModal,
    closeModal,
    save,
    errors,
    loading,
    snackbarProps,
  };
}
